export const INBOX_CTA_TITLES = Object.freeze({
  VIEW_CANCELLATION_DETAILS: "VIEW_CANCELLATION_DETAILS",
  EXPLORE_SPACES: "EXPLORE_SPACES",
  CONTACT_PEERSPACE_SUPPORT: "CONTACT_PEERSPACE_SUPPORT",
  BOOK_NOW: "BOOK_NOW",
  START_BOOKING: "START_BOOKING",
  WITHDRAW_BOOKING: "WITHDRAW_BOOKING",
  UPDATE_BOOKING: "UPDATE_BOOKING",
  CANCEL_BOOKING: "CANCEL_BOOKING",
  BROWSE_ADDONS: "BROWSE_ADDONS",
  RESEND_BOOKING: "RESEND_BOOKING",
  LEAVE_REVIEW: "LEAVE_REVIEW",
  BOOK_AGAIN: "BOOK_AGAIN",
  VIEW_RECEIPT: "VIEW_RECEIPT",
  RETRY_BOOKING: "RETRY_BOOKING",
  REVIEW_CUSTOM_OFFER: "REVIEW_CUSTOM_OFFER",
  REVIEW_UPDATE_REQUEST: "REVIEW_UPDATE_REQUEST",
  RETRY_UPDATE: "RETRY_UPDATE",
  WITHDRAW_UPDATE: "WITHDRAW_UPDATE",
  CREATE_CUSTOM_OFFER: "CREATE_CUSTOM_OFFER",
  REVIEW_BOOKING_REQUEST: "REVIEW_BOOKING_REQUEST",
  ADD_PAYOUT_INFO: "ADD_PAYOUT_INFO",
  OFFER_CUSTOM_PRICE: "OFFER_CUSTOM_PRICE",
  WITHDRAW_OFFER: "WITHDRAW_OFFER",
  EDIT_OFFER: "EDIT_OFFER",
  UPDATE_INVITE: "UPDATE_INVITE",
  AUTHORIZE_PAYMENT: "AUTHORIZE_PAYMENT",
  RETRY_PAYMENT: "RETRY_PAYMENT",
  MANAGE_PAYMENTS: "MANAGE_PAYMENTS",
  CREATE_OFFER: "CREATE_OFFER",
  VIEW_BOOKING_DETAILS: "VIEW_BOOKING_DETAILS"
});
